module.exports = ".btn-cancel { \r\n\tcolor: #757575;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/confirm-dialog/confirm-dialog.component.css
// module id = ./src/app/shared/components/confirm-dialog/confirm-dialog.component.css
// module chunks = main